import {SET_DAYS} from "../../types";

export function setParamsTradingDurationModal(data) {
    return (dispatch) => {
        dispatch({type: SET_DAYS, payload: data});
    }
}

